// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__Np5jC","errorLogs":"EditorFooter_errorLogs__1omj2"};